var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 78,
    viewBox: "0 0 72 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_112_1326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5 6.44338C35.047 5.55021 36.953 5.55021 38.5 6.44338L56.8827 17.0566C58.4297 17.9498 59.3827 19.6004 59.3827 21.3868V42.6132C59.3827 44.3996 58.4297 46.0502 56.8827 46.9434L38.5 57.5566C36.953 58.4498 35.047 58.4498 33.5 57.5566L15.1173 46.9434C13.5703 46.0502 12.6173 44.3996 12.6173 42.6132V21.3868C12.6173 19.6004 13.5703 17.9498 15.1173 17.0566L33.5 6.44338Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7734 35.3651V25.5674C25.7734 24.2071 26.5609 23.8799 27.5223 24.8412L30.1712 27.4901C30.57 27.889 31.2246 27.889 31.6132 27.4901L35.2746 23.8185C35.6734 23.4196 36.328 23.4196 36.7166 23.8185L40.3882 27.4901C40.7871 27.889 41.4416 27.889 41.8303 27.4901L44.4791 24.8412C45.4405 23.8799 46.228 24.2071 46.228 25.5674V35.3753C46.228 38.4435 44.1825 40.4889 41.1143 40.4889H30.8871C28.0643 40.4787 25.7734 38.1878 25.7734 35.3651Z",
    stroke: "#EFBF04",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_112_1326",
    x: 0.617188,
    y: 0.773499,
    width: 70.7656,
    height: 76.453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_112_1326"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_112_1326",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownIcon);
export default __webpack_public_path__ + "static/media/crown-icon.a082028d8762fd7d62439f86ac38aca7.svg";
export { ForwardRef as ReactComponent };